/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, TextField, AutoTab, TabItem } from '@one-snap/sparkles';
import { Grid, Container, FormControl, Alert } from '@mui/material';
import moment from 'moment';
import axios from 'axios';
import Navbar from '../stores/Navbar';
import './ApiPageStyles.css';

function ApiPage() {
  const location = useLocation();
  const captureFormRef = useRef(null);
  const cancelFormRef = useRef(null);
  const refundFormRef = useRef(null);
  const { env, token, audience, approvedAppId } = location.state;

  useEffect(() => {
    document.documentElement.style.overflowY = 'scroll';
  }, []);

  const captureInitialValues = {
    captureApplicationId: approvedAppId,
    deliveryDate: moment().format('YYYY-MM-DD')
  };

  const cancelInitialValues = {
    cancelApplicationId: approvedAppId
  };

  const refundInitialValues = {
    refundApplicationId: approvedAppId,
    refundAmount: '10'
  };

  const [isCaptureBtnLoading, setCaptureBtnLoading] = useState(false);
  const [isRefundLoading, setRefundLoading] = useState(false);
  const [isCancelLoading, setCancelLoading] = useState(false);
  const [formValues, setFormValues] = useState(captureInitialValues);
  const [cancelFormValues, setCancelFormValues] = useState(cancelInitialValues);
  const [refundFormValues, setRefundFormValues] = useState(refundInitialValues);
  const [isAlertVisible, setAlertVisible] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState('success');
  const [alertMsg, setAlertMsg] = useState('Message');
  const [isCancelAlertVisible, setCancelAlertVisible] = useState(false);
  const [cancelAlertSeverity, setCancelAlertSeverity] = useState('success');
  const [cancelAlertMsg, setCancelAlertMsg] = useState('Message');
  const [isRefundAlertVisible, setRefundAlertVisible] = useState(false);
  const [refundAlertSeverity, setRefundAlertSeverity] = useState('success');
  const [refundAlertMsg, setRefundAlertMsg] = useState('Message');
  const [activeTab, setActiveTab] = useState('tab1');

  const handleCaptureChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancelChange = (event) => {
    const { name, value } = event.target;
    setCancelFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleRefundChange = (event) => {
    const { name, value } = event.target;
    setRefundFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const onAlertClose = () => {
    setAlertVisible(false);
  };

  const onCancelAlertClose = () => {
    setCancelAlertVisible(false);
  };

  const onRefundAlertClose = () => {
    setRefundAlertVisible(false);
  };

  const handleCaptureSubmit = async (event) => {
    event.preventDefault();
    try {
      setCaptureBtnLoading(true);
      const url =
        env === 'Prod'
          ? `https://api.snapfinance.com/platform/v1/application/${approvedAppId}/capture`
          : `https://api-${env}.snapfinance.com/platform/v1/application/${approvedAppId}/capture`;
      const headers = {
        'Content-Type': 'application/json',
        'Referrer-Policy': 'no-referrer-when-downgrade',
        Authorization: `Bearer ${token}`
      };

      const captureData = {
        deliveryDate: captureInitialValues.deliveryDate
      };
      const response = await axios.post(url, captureData, { headers });
      setCaptureBtnLoading(false);
      setAlertMsg(JSON.stringify(response.data));
      setAlertSeverity('success');
      setAlertVisible(true);
    } catch (error) {
      setCaptureBtnLoading(false);
      console.error(error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'An unknown error occurred';
      setAlertMsg(errorMessage.toString());
      setAlertSeverity('error');
      setAlertVisible(true);
    }
  };

  const handleCancelSubmit = async (event) => {
    event.preventDefault();
    setCancelLoading(true);
    const url =
      env === 'Prod'
        ? `https://api.snapfinance.com/platform/v1/application/${approvedAppId}/cancel`
        : `https://api-${env}.snapfinance.com/platform/v1/application/${approvedAppId}/cancel`;

    try {
      const cancelData = {
        reason: 'the customer and merchant have agreed to cancel this order'
      };

      const headers = {
        'Content-Type': 'application/json',
        'Referrer-Policy': 'no-referrer-when-downgrade',
        Authorization: `Bearer ${token}`
      };

      const response = await axios.post(url, cancelData, { headers });
      setCancelLoading(false);
      setCancelAlertSeverity('success');
      setCancelAlertMsg(JSON.stringify(response.data));
      setCancelAlertVisible(true);
    } catch (error) {
      setCancelLoading(false);
      setCancelAlertSeverity('error');
      console.error(error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'An unknown error occurred';
      setCancelAlertMsg(JSON.stringify(errorMessage));
      setCancelAlertVisible(true);
    }
  };

  const handleRefundSubmit = async (event) => {
    event.preventDefault();
    try {
      setRefundLoading(true);
      const url =
        env === 'Prod'
          ? `https://api.snapfinance.com/platform/v1/application/${approvedAppId}/refund`
          : `https://api-${env}.snapfinance.com/platform/v1/application/${approvedAppId}/refund`;
      const headers = {
        'Content-Type': 'application/json',
        'Referrer-Policy': 'no-referrer-when-downgrade',
        Authorization: `Bearer ${token}`
      };

      const refundData = {
        adjustment: {
          amount: `-${refundInitialValues.refundAmount}`
        }
      };

      const response = await axios.post(url, refundData, { headers });
      setRefundLoading(false);
      setRefundAlertSeverity('success');
      setRefundAlertMsg(JSON.stringify(response.data));
      setRefundAlertVisible(true);
    } catch (error) {
      console.error(error);
      setRefundLoading(false);
      setRefundAlertSeverity('error');
      console.error(error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'An unknown error occurred';
      setRefundAlertMsg(JSON.stringify(errorMessage));
      setRefundAlertVisible(true);
    }
  };

  const getCaptureContent = () => {
    const endpoint =
      env === 'Prod'
        ? `https://api.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/capture`
        : `https://api-${env.toLowerCase()}.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/capture`;
    return (
      <div id="captureTabPane" className="api-store-card-div">
        <form
          ref={captureFormRef}
          onSubmit={handleCaptureSubmit}
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 15
          }}
        >
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="outlined">
                <TextField
                  type="date"
                  value={formValues.deliveryDate}
                  onChange={handleCaptureChange}
                  label="Delivery Date"
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <TextField
                  label="Application ID"
                  id="captureApplicationIdInput"
                  value={formValues.captureApplicationId}
                  onChange={handleCaptureChange}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                size="medium"
                variant="contained"
                color="primary"
                disabled={isCaptureBtnLoading}
                style={{ marginLeft: 10 }}
                loading={isCaptureBtnLoading}
              >
                Capture Application
              </Button>
            </Grid>
          </Grid>
        </form>
        {isAlertVisible && (
          <Alert severity={alertSeverity} onClose={onAlertClose}>
            {alertMsg}
          </Alert>
        )}
        <hr />
        <div className="api-info-txt">API Information</div>
        <div className="ref-text">
          <div>
            This endpoint updates the application delivery date changes its
            status from PENDING_DEL to COMPLETE and initiates the process to
            fund the application.
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Endpoint: </span>
            <span>{endpoint}</span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Request Body: </span>
            <span>{`{ "deliveryDate": "2020-07-08" }`}</span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Response 200 OK: </span>
            <span>{`{"success": true, "data": {}, "status": 200}`}</span>
          </div>
          <div>
            <span>Response 404 NOT FOUND: </span>
          </div>
          <div>
            <span>
              {`{"success": false, "status": 404, "error": [{"type": "validation_error","message": "Application not found","code": "application_not_found"}]}`}
            </span>
          </div>
        </div>
        <p>
          Reference:{' '}
          <a
            className="reference-hyperlink"
            href="https://platform.api-spec.snapfinance.com/#fc5f1bdc-6047-4a72-9ff3-8e96e34b3fe7"
            target="_blank"
            rel="noopener noreferrer"
            title="Link to Platform API Spec"
          >
            API Documentation
          </a>
        </p>
      </div>
    );
  };

  const getRefundContent = () => {
    const endpoint =
      env === 'Prod'
        ? `https://api.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/refund`
        : `https://api-${env.toLowerCase()}.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/refund`;
    return (
      <div id="refundTabPane" className="api-store-card-div">
        <form
          ref={refundFormRef}
          onSubmit={handleRefundSubmit}
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 15
          }}
        >
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="outlined">
                <TextField
                  label="Application ID"
                  id="refundApplicationIdInput"
                  value={refundFormValues.refundApplicationId}
                  onChange={handleRefundChange}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <TextField
                  label="Refund Amount"
                  id="refundApplicationAmountInput"
                  value={refundFormValues.refundAmount}
                  onChange={handleRefundChange}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                size="medium"
                variant="contained"
                color="primary"
                disabled={isRefundLoading}
                style={{ marginLeft: 10 }}
                loading={isRefundLoading}
              >
                Refund Application
              </Button>
            </Grid>
          </Grid>
        </form>
        {isRefundAlertVisible && (
          <Alert severity={refundAlertSeverity} onClose={onRefundAlertClose}>
            {refundAlertMsg}
          </Alert>
        )}
        <hr />
        <div className="api-info-txt">API Information</div>
        <div className="ref-text">
          <div>
            This endpoint refunds full or partial payment on LTO applications
            and changes its sub-status to either Refunded or Partially Refunded.
            There are two ways to do it, check the next request options.
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Endpoint: </span>
            <span>{endpoint}</span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Request Body: </span>
            <span>
              {`{
                      "products": [
                        {
                          "amount": "1.00",
                          "itemId": "ABC",
                          "quantity": 1
                        }
                      ]
                    }`}
            </span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Response 200 OK: </span>
            <span> {`{"success": true, "data": {}, "status": 200}`}</span>
          </div>
          <div>
            <span>Response 404 NOT FOUND: </span>
          </div>
          <div>
            <span>
              {`{ "success": false,"error": [{"type": "validation_error","message": "Application not found","code": "application_not_found"}],"status": 404}`}
            </span>
          </div>
        </div>
        <p>
          Reference:{' '}
          <a
            className="reference-hyperlink"
            href="https://platform.api-spec.snapfinance.com/#cf74eb75-70f5-4331-b5bb-e20d2ed7a7da"
            target="_blank"
            rel="noopener noreferrer"
          >
            API Documentation
          </a>
        </p>
      </div>
    );
  };

  const getCancelContent = () => {
    const endpoint =
      env === 'Prod'
        ? `https://api.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/cancel`
        : `https://api-${env.toLowerCase()}.snapfinance.com/platform/v1/application/${
            approvedAppId || '<test_app_id>'
          }/cancel`;
    return (
      <div id="cancelApplicationId" className="api-store-card-div">
        <form
          ref={cancelFormRef}
          onSubmit={handleCancelSubmit}
          style={{
            marginTop: 20,
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 15
          }}
        >
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item>
              <FormControl variant="outlined">
                <TextField
                  label="Application ID"
                  id="cancelApplicationIdInput"
                  value={cancelFormValues.cancelApplicationId}
                  onChange={handleCancelChange}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                size="medium"
                variant="contained"
                color="primary"
                disabled={isCancelLoading}
                style={{ marginLeft: 10 }}
                loading={isCancelLoading}
              >
                Cancel Application
              </Button>
            </Grid>
          </Grid>
        </form>
        {isCancelAlertVisible && (
          <Alert severity={cancelAlertSeverity} onClose={onCancelAlertClose}>
            {cancelAlertMsg}
          </Alert>
        )}
        <hr />
        <div className="api-info-txt">API Information</div>
        <div className="ref-text">
          <div>
            This endpoint cancels the application that is not funded and changes
            the application status to Withdrawn.
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Endpoint: </span>
            <span>{endpoint}</span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Request Body: </span>
            <span> {`{ "reason": "reason to cancel" }`}</span>
          </div>
          <div style={{ textAlign: 'left' }}>
            <span>Response 200 OK: </span>
            <span>{`{"success": true, "data": {}, "status": 200}`}</span>
          </div>
        </div>
        <p>
          Reference:{' '}
          <a
            className="reference-hyperlink"
            href="https://platform.api-spec.snapfinance.com/#aeb7efc5-b5ec-4152-b702-b08d8187e039"
            target="_blank"
            rel="noopener noreferrer"
          >
            API Documentation
          </a>
        </p>
      </div>
    );
  };

  return (
    <div className="api-sdk-store-container-bg">
      <Navbar
        audience={audience}
        env={env}
        token={token}
        isHomeScreen={false}
      />
      <Container maxWidth="lg" className="api-sdk-store-container">
        <AutoTab defaultTab="custom_tab1">
          <TabItem tabId="custom_tab1" onClick={() => setActiveTab('tab1')}>
            Capture Application
          </TabItem>
          <TabItem tabId="custom_tab2" onClick={() => setActiveTab('tab2')}>
            Refund Application
          </TabItem>
          <TabItem tabId="custom_tab3" onClick={() => setActiveTab('tab3')}>
            Cancel Application
          </TabItem>
        </AutoTab>
        <div className="api-info-section">
          {activeTab === 'tab1' && getCaptureContent()}
          {activeTab === 'tab2' && getRefundContent()}
          {activeTab === 'tab3' && getCancelContent()}
        </div>
        <div style={{ padding: 70 }} />
      </Container>
    </div>
  );
}

export default ApiPage;
